import Section, { SectionContent, Paragraph } from "./section"
import SectionHeader from "./section-header"
import ContentGroup from "./content-group"
import ContentItem from "./content-item"
import DefinitionList from "./definition-list"
import ListLink from "./list-link"
import PageBody from "./page-body"

import Layout from "./layout"

// provide named exports
export {
  Section,
  SectionHeader,
  SectionContent,
  PageBody,
  Paragraph,
  ContentGroup,
  ContentItem,
  DefinitionList,
  ListLink,
}

export default Layout
